<template>
	<div class="page-component__scroll">
		<div class="product-wrap flex-row flex-just-between">
			<!-- 商品左侧栏 -->
			<div class="product-left mr-28">
				<template v-if="isShowSource">
					<p class="mb-10 fz-14" v-if="shopDetailObj['source_type'] === '1'">
						<span class="yx-color-text-regular">来源：</span>
						<span>{{ shopDetailObj.partner_name }}</span>
						<span class="yx-color-text-regular">上传的</span>
						{{ '货盘表“' + shopDetailObj.pallet_name + '(ID:' + shopDetailObj.pallet_id + ')”' }}
					</p>
					<p class="mb-10 fz-14" v-else>
						<span class="yx-color-text-regular">来源：</span>
						<span>{{ shopDetailObj['source_type'] === '3' ? shopDetailObj.product_type_name : shopDetailObj.source_type_desc }}</span>
					</p>
				</template>
				<div class="productImg">
					<div class="big-image">
						<img
							:src="
								shopDetailObj.product_images && shopDetailObj.product_images.length ? shopDetailObj.product_images[active] : shopDetailObj.product_pic
							"
						/>
						<div class="recommend" v-if="shopDetailObj.promote_status != promoteStatus.open">暂停推广</div>
					</div>
					<div class="small-image-box" v-if="shopDetailObj.product_images && shopDetailObj.product_images.length">
						<div
							class="small-image-bg"
							:class="{ active: active == index }"
							@mousemove="hoverFun(index)"
							v-for="(item, index) in shopDetailObj.product_images"
							:key="index"
						>
							<img :src="item" class="small-image" />
						</div>
					</div>
					<div class="small-image-box" v-else>
						<div class="small-image-bg">
							<img :src="shopDetailObj.product_pic" class="small-image" />
						</div>
					</div>
				</div>
				<!-- 店铺信息，联系商家 -->
				<div class="w100 pl-20 pr-20 pt-20 pb-20 mt-24 shop-wrapper">
					<div class="flex">
						<svg class="icon shop-logo" aria-hidden="true">
							<use xlink:href="#icon-ic_24_dianpu"></use>
						</svg>
						<div class="flex-1 flex flex-just-center flex-just-between">
							<div>
								<div class="mb-4 fz-14 color-text-primary font-bold">{{ shopDetailObj.shop_name }}</div>
								<div class="flex-row">
									<span class="shop-tag pl-4 pr-4">小店</span>
								</div>
							</div>
							<div v-if="$isPlatOr(shopDetailObj.platform_id, ['Ks', 'Sp'])">
								<div class="ml-5 text-align-center">
									<span class="Barlow-SemiBold fz-16 yx-color-text-primary">{{ shopDetailObj.shop_scores.shop_score | formatEmpty }}</span>
								</div>
								<div class="mt-4 fz-12 yx-color-text-secondary">商家体验分</div>
							</div>
						</div>
					</div>
					<shop-score
						v-if="$isDy(shopDetailObj.platform_id)"
						:shopScores="{
							shopScore: shopDetailObj.shop_scores.shop_score,
							shopScoreLevel: shopDetailObj.shop_scores.shop_score_level,
							productScore: shopDetailObj.shop_scores.product_score,
							productScoreLevel: shopDetailObj.shop_scores.product_score_level,
							logisticsScore: shopDetailObj.shop_scores.logistics_score,
							logisticsScoreLevel: shopDetailObj.shop_scores.logistics_score_level,
							serviceScore: shopDetailObj.shop_scores.service_score,
							serviceScoreLevel: shopDetailObj.shop_scores.service_score_level,
						}"
					/>
				</div>
				<!-- 销售数据 -->
				<div class="w100 pl-20 pr-20 pt-10 pb-20 mt-12 shop-wrapper" v-if="showSaleData">
					<div class="flex flex-align-center flex-just-between">
						<p class="mb-4 fz-14 color-text-primary font-bold">销售数据</p>
						<p class="mb-4 fz-12 color-text-primary colortext">---更新</p>
					</div>
					<ul class="flex flex-align-center mt-15 flex-just-between dinpro">
						<li class="align-center">
							<p class="font-bold mb-10">{{ shopDetailObj.product_sales ? shopDetailObj.product_sales.yesterday_sales : '0' }}</p>
							<p class="fz-12 colortext">昨日销量</p>
						</li>
						<li class="align-center">
							<p class="font-bold mb-10">{{ shopDetailObj.product_sales ? shopDetailObj.product_sales.last_week_sales : '0' }}</p>
							<p class="fz-12 colortext">7日销量</p>
						</li>
						<li class="align-center">
							<p class="font-bold mb-10">{{ shopDetailObj.product_sales ? shopDetailObj.product_sales.last_month_sales : '0' }}</p>
							<p class="fz-12 colortext">30日销量</p>
						</li>
						<li class="align-center">
							<p class="font-bold mb-10">{{ shopDetailObj.product_sales ? shopDetailObj.product_sales.total_sales : '0' }}</p>
							<p class="fz-12 colortext">总销量</p>
						</li>
					</ul>
				</div>
			</div>
			<!-- 商品右侧栏 -->
			<div class="product-right">
				<p class="mb-10 shop_id">
					<span class="yx-color-text-regular">商品ID：</span>
					<span>{{ shopDetailObj.third_product_id }}</span>
				</p>
				<div>
					<!-- 主标题 -->
					<div class="productTitle ellipsis-2 flex flex-align-center">
						<platform-icon :platformId="shopDetailObj.platform_id" class="mr-6"></platform-icon>
						{{ shopDetailObj.product_name }}
					</div>
					<!-- 品牌 -->
					<div class="flex-row flex-align-center flex-just-between">
						<div class="flex fz-12 pl-6 pr-6">
							<span class="team_pro mr-6" v-if="shopDetailObj['product_type_name']">{{ shopDetailObj['product_type_name'] }}</span>
							<span class="pr-4 pl-4 pt-2 pb-2 brand-name" v-if="shopDetailObj.brand_name">{{ shopDetailObj.brand_name }}</span>
							<span class="pr-4 pl-4 pt-2 pb-2 ml-6 brand-text" v-if="shopDetailObj.cate_name">{{ shopDetailObj.cate_name }}</span>
						</div>
						<div class="fz-12 pl-6 pr-6 cor-FA8F14">
							<span class="pr-4">推荐给达人：</span>
							<span class="pl-4">{{ shopDetailObj.product_share_total }}次</span>
						</div>
					</div>
					<!-- 商品价格 -->
					<div class="flex-row mt-20">
						<!-- 营销活动佣金率 -->
						<div class="flex-1">
							<div class="flex-row baseline">
								<span class="sfpro tourist font-bold">
									<span>{{ shopDetailObj.commission_rate }}</span>
									<span class="fz-14">%</span>
								</span>
								<div class="number-text fz-12">佣金率</div>
							</div>
						</div>
						<!-- 提成比 -->
						<div class="flex-1" v-if="isDrPartnerDataView && rate_status">
							<div class="flex-row baseline">
								<span class="sfpro tourist font-bold">
									<span>{{ shopDetailObj.partner_rate }}</span>
									<span class="fz-14">%</span>
								</span>
								<div class="number-text fz-12">提成比</div>
							</div>
						</div>
						<!-- 预估赚 -->
						<div class="flex-1">
							<div class="flex-row baseline mr-4">
								<span class="font-bold pr-4">
									<span class="fz-14">￥</span>
									<span class="sfpro fz-28">{{ live_price[0] }}</span>
									<span class="sfpro fz-14" v-if="live_price[1]">.{{ live_price[1] }}</span>
								</span>
								<div class="number-text fz-12">直播价</div>
							</div>
						</div>
						<!-- 直播价，日常价 -->
						<div class="flex-1">
							<div class="flex-row baseline mr-4">
								<span class="font-bold pr-4">
									<span class="fz-14">￥</span>
									<span class="sfpro fz-28">{{ sale_price[0] }}</span>
									<span class="sfpro fz-14" v-if="sale_price[1]">.{{ sale_price[1] }}</span>
								</span>
								<div class="number-text fz-12">现售价</div>
							</div>
						</div>
					</div>
					<!-- 销量 -->
					<div class="flex pt-10 pb-10 mt-20 mb-20 fz-12 sales-box flex-align-center flex-just-around" v-if="false">
						<p>
							销量
							<span class="ml-6 cor-FA8F14">--</span>
						</p>
						<div></div>
						<p>
							库存量
							<span class="ml-6 font-bold">--</span>
						</p>
					</div>
					<!-- 商品其他信息 -->
					<ul class="flex-cloumn mt-16">
						<li class="flex-row mb-12 fz-12 flex-align-center" v-if="shopDetailObj.sku_list && shopDetailObj.sku_list.length">
							<span class="product-label">规格</span>
							<span class="color-text-regular">{{ specification }}</span>
						</li>
						<li class="flex-row mb-12 fz-12 flex-align-center" v-else>
							<span class="product-label">规格</span>
							<span class="color-text-regular">{{ shopDetailObj.spec }}</span>
						</li>
						<li class="flex-row mb-12 fz-12" v-if="shopDetailObj.gifts">
							<span class="product-label">赠品</span>
							<span class="color-text-regular">{{ shopDetailObj.gifts }}</span>
						</li>
						<li class="flex-row mb-12 fz-12" v-if="shopDetailObj.delivery_site">
							<span class="product-label">发货</span>
							<span class="color-text-regular">{{ shopDetailObj.delivery_site }}</span>
						</li>
						<li class="flex-row fz-12" v-if="shopDetailObj.remark">
							<span class="product-label">备注</span>
							<span class="color-text-regular">{{ shopDetailObj.remark }}</span>
						</li>
					</ul>
				</div>
				<!--商品优势-->
				<div class="product-advantage mt-16" v-if="shopDetailObj.selling_points">
					<div class="flex flex-just-between">
						<p class="title font-bold">商品卖点</p>
						<p class="yx-color-primary fz-12 copy" @click="copy(shopDetailObj.selling_points)">复制</p>
					</div>
					<pre>{{ shopDetailObj.selling_points }}</pre>
				</div>
				<!--商品详情第二部分 start-->
				<div class="product-detail-wrap mt-16">
					<div class="mb-30">
						<div class="pl-20 pt-20 pr-20 pb-20">
							<div class="fz-14 color-text-primary mb-12 font-bold">商品详情</div>
							<ul class="product-detail clearfix">
								<li>
									{{ '商品分类：' + shopDetailObj.cate_name }}
								</li>
								<li>
									{{ '商铺名称：' + shopDetailObj.shop_name }}
								</li>
							</ul>
						</div>
						<!-- 商品描述图 -->
						<template v-if="$isPlatOr(shopDetailObj.platform_id, ['Sp', 'Xhs'])">
							<div class="product-detail-imgs" v-if="shopDetailObj.detail_images && shopDetailObj.detail_images.length">
								<img :src="item" class="mt-6" v-for="(item, index) in shopDetailObj.detail_images" :key="index" />
							</div>
							<div class="product-detail-imgs" v-else>
								<img :src="shopDetailObj.product_pic" class="mt-6" />
							</div>
						</template>
						<template v-if="$isPlatOr(shopDetailObj.platform_id, ['Dy', 'Ks'])">
							<div class="product-detail-imgs" v-if="shopDetailObj.product_images && shopDetailObj.product_images.length">
								<img :src="item" class="mt-6" v-for="(item, index) in shopDetailObj.product_images" :key="index" />
							</div>
							<div class="product-detail-imgs" v-else>
								<img :src="shopDetailObj.product_pic" class="mt-6" />
							</div>
						</template>
					</div>
					<!-- <div v-else class="details-bottom">
          <div class="pl-20 pt-20 pr-20 pb-20">
            <div class="fz-14 color-text-primary mb-12 font-bold">商品详情</div>
          </div>
          <div class="db-img yx-color-text-primary">
            <img src="@/assets/public/empty-img.png" alt="">
            <div>因快手官方规则限制，暂不支持返回该商品数据，<br/>请<span class="yx-color-primary pointer">点击跳转</span>至官方详情页查看</div>
          </div>
        </div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { promoteStatus } from '@/utils/dataMap';
import { mapGetters, mapState } from 'vuex';
import shopScore from '@/components/shopScore/view.vue';
export default {
	name: 'MDetail',
	props: {
		shopDetailObj: {
			type: Object,
			default: _ => ({}),
		},
		isShowSource: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		shopScore,
	},
	data() {
		return {
			active: 0,
			promoteStatus,
		};
	},
	computed: {
		...mapState(['vuex_userInfo']),
		...mapGetters(['isDrPartnerDataView']),
		rate_status() {
			return this.vuex_userInfo?.rate_status;
		},
		live_price() {
			return (this.shopDetailObj.live_price || '').split('.');
		},
		sale_price() {
			return (this.shopDetailObj.sale_price || '').split('.');
		},
		showSaleData() {
			return this.$isDy(this.shopDetailObj?.platform_id);
		},
		specification() {
			return this.shopDetailObj?.sku_list?.map(item => item.specification)?.join('、');
		},
	},
	methods: {
		hoverFun(index) {
			this.active = index;
		},
		copy(value) {
			let self = this;
			if (!value) {
				self.$message.error('该商品无链接');
				return;
			}
			var inputTest = document.createElement('textarea');
			inputTest.value = value;
			document.body.appendChild(inputTest);
			inputTest.select();
			document.execCommand('Copy');
			inputTest.className = 'oInput';
			inputTest.style.display = 'none';
			self.$message.success('复制成功');
			document.body.removeChild(inputTest);
		},
	},
};
</script>

<style scoped lang="less">
/deep/ .el-dialog__body {
	padding: 0;
}
.rejectPopUp {
	border-top: 1px solid #dcdee0;
	padding: 24px;
	color: #323233;
	font-size: 14px;
}
.tourist {
	color: #f03525;
	font-size: 28px;
	padding-right: 4px;
}
.page-component__scroll {
	height: 100%;
	overflow-y: auto;
	color: #333;
	&::-webkit-scrollbar {
		display: none;
	}
}
/deep/ .el-input-number {
	width: 140px;
	line-height: 36px;
}
/deep/ .el-input__inner {
	height: 36px !important;
	line-height: 36px !important;
}
/deep/ .el-image {
	display: block;
}
/deep/ .el-input-number__decrease {
	height: 34px;
	line-height: 34px;
}
/deep/ .el-input-number__increase {
	height: 34px;
	line-height: 34px;
}
// 全圆角
.tag2(@color, @bgColor, @size) {
	color: @color;
	font-size: @size;
	background-color: @bgColor;
	border-radius: 2px;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: center;
}
// 左下角是直角
.tag1(@color, @bgColor, @size, @borderRadius) {
	color: @color;
	font-size: @size;
	background-color: @bgColor;
	border-radius: @borderRadius @borderRadius @borderRadius 0;
	display: flex;
	align-items: center;
	justify-content: center;
}
.product-wrap {
	width: 1000px;
	margin: 0 auto;
}
.product-left {
	.productImg {
		.big-image {
			position: relative;
			background-color: #f6f6f6;
			border-radius: 4px;
			overflow: hidden;
			width: 364px;
			height: 364px;
			position: relative;
			img {
				width: auto;
				height: auto;
				max-width: 364px;
				max-height: 364px;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
		.small-image-box {
			width: 364px;
			overflow-x: auto;
			margin-top: 6px;
			display: flex;
			align-items: center;
			.small-image-bg {
				background-color: #f6f6f6;
				border-radius: 4px;
				overflow: hidden;
				width: 68px;
				height: 68px;
				position: relative;
				cursor: pointer;
				border: 2px solid rgba(0, 0, 0, 0);
				box-sizing: border-box;
				flex-shrink: 0;
				&.active {
					border: 2px solid @color-primary;
				}
				&:not(:last-child) {
					margin-right: 6px;
				}
				.small-image {
					width: auto;
					height: auto;
					max-width: 68px;
					max-height: 68px;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
				}
			}
		}
	}
	.shop-wrapper {
		border: 1px solid #eeeeee;
		border-radius: 4px;
		.img {
			width: 40px;
			height: 40px;
			border-radius: 4px;
		}
		.shop-tag {
			.tag2(@color-primary, #e9f1ff, 12px);
		}
	}
	.border-bottom {
		border-bottom: 1px solid #eeeeee;
	}
	.bg-color {
		background-color: #f8f8f8;
		border: 1px solid transparent;
	}
	.bg-color:hover {
		cursor: pointer;
		background-color: #ffffff;
		border: 1px solid #0fb820;
		border-radius: 5px;
	}
	.colortext {
		color: #999;
	}
	.bg-color:hover .colortext {
		color: #0fb820;
	}
}
// 商品右边栏
.product-right {
	.shop_id {
		text-align: right;
		font-size: 14px;
	}
	width: 608px;
	// 主标题
	.productTitle {
		position: relative;
		line-height: 24px;
		font-size: 16px;
		font-weight: 600;
		color: @color-text-primary;
		margin: 12px 0;
		.img {
			display: inline-block;
			margin-right: 10px;
			width: 16px;
			height: 16px;
		}
	}
	// 品牌
	.brand-name {
		color: #ae6c41;
		background-color: #fff2e9;
		border-radius: 2px;
		font-weight: 500;
	}
	.brand-text {
		color: #666666;
		background-color: #f8f8f8;
		border-radius: 2px;
		font-weight: 500;
	}

	// 原价
	.origin_price {
		padding: 0 6px;
		.tag1(#656774, #f6f6f6, 12px, 8px);
	}
	// 商品其他信息标签
	.product-label {
		margin-right: 16px;
		width: 84px;
		color: #8f9399;
	}
	// 商品详情
	.product-detail-wrap {
		border-radius: 4px 4px 0 0;
		border: 1px solid #eeeeee;
		border-bottom: none;
	}
	// 商品优势
	.product-advantage {
		width: 608px;
		padding: 12px 12px 20px;
		border-radius: 4px;
		border: 1px solid #eeeeee;
		color: #656774;
		font-size: 12px;
		line-height: 21px;
		box-sizing: border-box;
		.title {
			color: #1b1e2d;
			font-size: 16px;
		}
		pre {
			font-display: 'PingFang SC', 'Helvetica Neue', Helvetica, 'Hiragino Sans GB', 'Microsoft YaHei', '\5FAE\8F6F\96C5\9ED1', Arial, sans-serif;
			white-space: pre-wrap;
		}
	}
	// 商品详情图
	.product-detail-imgs {
		min-height: 50px;
		img {
			max-width: 100%;
			display: block;
		}
	}
	// 营销商品库存
	.super-product {
		padding: 0 8px;
		height: 28px;
		border-radius: 2px;
		background-color: @color-primary;
		.time-item {
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 0 4px;
			width: 20px;
			height: 20px;
			background: @color-text-primary;
			border-radius: 2px;
			&:last-of-type {
				margin-right: 0;
			}
		}
	}
	// 普通佣金率
	.normal_commision_rate {
		display: flex;
		align-items: center;
		line-height: 1em;
		.tag1(#195ed5, #e8eefa, 12px, 100px);
	}
	//销量
	.sales-box {
		border-top: 1px solid #eeeeee;
		border-bottom: 1px solid #eeeeee;
	}
}
.product-detail {
	li {
		width: 50%;
		font-size: 12px;
		color: @color-text-regular;
		float: left;
		font-size: 12px;
		line-height: 24px;
	}
}
.team_pro {
	border-radius: 2px;
	padding: 2px 4px;
	text-align: center;
	width: 75px;
	background-color: #ebf2fd;
	color: @color-primary;
}
.window-box {
	display: inline-block;
	position: relative;
	margin-left: 10px;
	.window-tip {
		position: absolute;
		top: -56px;
		left: 42px;
		width: 208px;
		height: 50px;
		padding-top: 18px;
		font-size: 12px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #ffffff;
		box-sizing: border-box;
		text-align: right;
	}
}
</style>
<style lang="less" scoped>
.btn {
	background: #f6f6f6;
	border-radius: 2px;
	color: @color-text-primary;
	&.no-boder {
		border: none;
	}
	&.primary {
		background: @color-primary;
		color: #fff;
		border: 1px solid @color-primary;
		&.plain {
			background: fade(@color-primary, 8%);
			color: @color-primary;
		}
	}
}
.color-white {
	color: white;
}
.cor-FA8F14 {
	color: #fa8f14;
}
.Specifications {
	padding: 4px 10px;
	border: 1px solid #f03525;
	background-color: #feeeed;
	color: #f03525;
	width: 500px;
	height: 28px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	margin-top: 16px;
	line-height: 28px;
}
.recommend {
	position: absolute;
	width: 120px;
	height: 120px;
	border-radius: 50%;
	background-color: rgba(0, 0, 0, 0.5);
	top: 50%;
	left: 50%;
	margin-left: -60px;
	margin-top: -60px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #fff;
}
.copy {
	cursor: pointer;
}
.baseline {
	align-items: baseline;
	.sfpro {
		font-family: SFPro-Black, SFPro;
	}
	.font-bold {
		font-weight: 900;
	}
	.number-text {
		color: #656774;
	}
}
.dinpro {
	font-family: DINPro-Bold, DINPro;
}
.shop-logo {
	font-size: 40px;
	width: 40px;
	height: 40px;
	border-radius: 2px;
	margin-right: 12px;
}
.details-bottom {
	margin-bottom: 100px;
	border-bottom: 1px solid #eeeeee;
	padding-bottom: 32px;
}
.db-img {
	text-align: center;
	img {
		width: 128px;
		height: 128px;
	}
}
</style>
